import React from 'react';
import {Provider} from "components/subject/SubjectContext";
import {SubjectList} from "components/subject/SubjectList";

export const Subjects = () => {

    return (
        <Provider>
            <SubjectList/>
        </Provider>
    );
}
